"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QRCodeWrap = exports.Image = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("./helpers");

var _constants = require("./constants");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  display: flex;\n  box-sizing: content-box;\n  justify-content: center;\n  align-items: center;\n  min-width: 1.875rem;\n  min-height: 1.875rem;\n  width: 1.875rem;\n  height: 1.875rem;\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-image: url(", ");\n  opacity: 1;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n  font-size: inherit;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Image = _styledComponents.default.div(_templateObject(), function (props) {
  return props.src;
});

exports.Image = Image;

var QRCodeWrap = _styledComponents.default.div(_templateObject2(), function (_ref) {
  var size = _ref.size;
  return size && "\n    width: ".concat((0, _helpers.convertSizeToRem)(size), "rem;\n    height: ").concat((0, _helpers.convertSizeToRem)(size), "rem;\n  ");
}, function (_ref2) {
  var framed = _ref2.framed,
      size = _ref2.size;
  return framed && "\n    box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.1);\n    border-radius: ".concat((0, _helpers.calculateProportion)(size, _constants.BORDER_RADIUS_FACTOR), "rem;\n    padding: ").concat((0, _helpers.calculateProportion)(size, _constants.PADDING_FACTOR), "rem;\n    background: #fff;\n  ");
});

exports.QRCodeWrap = QRCodeWrap;